import { COMMON_MOBILE_BREAKPOINT, useWindowWidth } from '@elfsight/lib-utils';

export function useNarrowView(bannerWidth: number | undefined) {
  const windowWidth = useWindowWidth();

  const isNarrowBanner = bannerWidth
    ? bannerWidth <= COMMON_MOBILE_BREAKPOINT
    : false;

  const isNarrowViewport = windowWidth <= COMMON_MOBILE_BREAKPOINT;

  return {
    isNarrowBanner,
    isNarrowViewport,
    isNarrow: isNarrowBanner || isNarrowViewport
  };
}
